import { css } from '@emotion/core';
import { variables, media } from '@domain-group/fe-brary';
var global = variables.global;
export var agencyProfile = {
  name: "79elbk",
  styles: "position:relative;"
};
export var bodySection = /*#__PURE__*/css("max-width:", global.desktopMinWidth, ";margin:0 auto;", media('>=tablet'), "{max-width:100%;}", media('>=desktop'), "{max-width:", global.desktopMinWidth, ";}");
export var insetBody = /*#__PURE__*/css("margin:0 16px;", media('>=tablet'), "{margin:0 18px;}", media('>=desktop'), "{margin:0;}");
export var recommendations = {
  name: "tik1gu",
  styles: "padding-bottom:5px;"
};
export var separator = /*#__PURE__*/css("margin-bottom:28px;", media('<tablet'), "{display:none;}");
export var listings = /*#__PURE__*/css("margin-top:32px;", media('>=tablet'), "{margin-top:45px;}");